import React from 'react';
import './fonts.css';
import { ThemeProvider, createTheme, CssBaseline } from '@mui/material';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import PrivacyPolicy from './components/policies/PrivacyPolicy';
import TermsOfService from './components/policies/TermsOfService';
import CookiePolicy from './components/policies/CookiePolicy';
import CookieConsent from './components/CookieConsent';
import './App.css';
import { AuthProvider } from './contexts/AuthContext';
import Login from './pages/Login';
import LoginSSO from './pages/LoginSSO';
import SSOLogin from './pages/SSOLogin';
import Admin from './pages/Admin';
import Manufacturer from './pages/Manufacturer';
import Dealer from './pages/Dealer';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import TremendousCallback from './pages/TremendousCallback';
import GoogleAnalytics from './components/GoogleAnalytics';

// Create a theme instance
const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#6C3BF8',
      light: '#7B4EF9',
      dark: '#5B32D6',
    },
    background: {
      default: '#ffffff',
      paper: '#f8f9fa',
    },
    text: {
      primary: '#2D3748',
      secondary: '#4A5568',
    },
  },
  typography: {
    fontFamily: '"Be Vietnam Pro", "Be Vietnam Pro Placeholder", sans-serif',
    h1: {
      fontWeight: 600,
      letterSpacing: '-0.02em',
      fontFamily: '"Be Vietnam Pro", "Be Vietnam Pro Placeholder", sans-serif',
    },
    h2: {
      fontFamily: '"Be Vietnam Pro", "Be Vietnam Pro Placeholder", sans-serif',
    },
    h3: {
      fontFamily: '"Be Vietnam Pro", "Be Vietnam Pro Placeholder", sans-serif',
    },
    h4: {
      fontFamily: '"Be Vietnam Pro", "Be Vietnam Pro Placeholder", sans-serif',
    },
    h5: {
      fontFamily: '"Be Vietnam Pro", "Be Vietnam Pro Placeholder", sans-serif',
    },
    h6: {
      fontFamily: '"Be Vietnam Pro", "Be Vietnam Pro Placeholder", sans-serif',
    },
    button: {
      fontWeight: 500,
      letterSpacing: '0.02em',
      fontFamily: '"Be Vietnam Pro", "Be Vietnam Pro Placeholder", sans-serif',
    },
    body1: {
      fontFamily: '"Be Vietnam Pro", "Be Vietnam Pro Placeholder", sans-serif',
    },
    body2: {
      fontFamily: '"Be Vietnam Pro", "Be Vietnam Pro Placeholder", sans-serif',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          textTransform: 'none',
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: 'rgba(26, 11, 46, 0.8)',
          backdropFilter: 'blur(20px)',
        },
      },
    },
  },
});

function AppContent() {
  const location = useLocation();
  const isAdminPage = location.pathname === '/admin';
  const isManufacturerPage = location.pathname === '/manufacturer';
  const isDealerPage = location.pathname === '/dealer';
  const isLoginPage = location.pathname === '/login' || location.pathname === '/' || location.pathname === '/sso';
  const shouldShowCookieConsent = isLoginPage;
  
  return (
    <div className={`app ${isAdminPage ? 'admin-page' : ''} ${isManufacturerPage ? 'manufacturer-page' : ''} ${isDealerPage ? 'dealer-page' : ''}`}>
      <GoogleAnalytics />
      <Routes>
        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route
          path="/login"
          element={
            process.env.REACT_APP_ENTRA_CLIENT_ID ? <LoginSSO /> : <Login />
          }
        />
        <Route path="/sso" element={<SSOLogin />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/callback" element={<TremendousCallback />} />
        <Route path="/organizations/:id" element={<TremendousCallback />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/manufacturer" element={<Manufacturer />} />
        <Route path="/dealer" element={<Dealer />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<TermsOfService />} />
        <Route path="/cookies" element={<CookiePolicy />} />
      </Routes>
      {shouldShowCookieConsent && <CookieConsent />}
    </div>
  );
}

function App() {
  return (
    <Router>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <AuthProvider>
          <AppContent />
        </AuthProvider>
      </ThemeProvider>
    </Router>
  );
}

export default App; 